import React from 'react';

export const PlanningView: React.FC = () => {
    return <p>PlanningView</p>;
};
